<template>
	<div class="app">
		<a href="#main-content" class="skip-link">Preskoči na sadržaj</a>
		<NavBar />
		<main id="main-content" tabindex="-1">
			<RouterView />
		</main>
		<Footer />
	</div>
</template>


<script setup>
import { RouterView } from 'vue-router'
import NavBar from './components/NavBar.vue'
import Footer from './components/Footer.vue'
</script>

<style scoped>
.skip-link {
	position: absolute;
	left: 1rem;
	top: -3rem;
	z-index: 200;
	background: var(--color-accent);
	color: var(--color-accent-contrast);
	padding: 0.6rem 1rem;
	border-radius: 8px;
	font-weight: 600;
	font-size: 0.85rem;
	transition: top 0.15s ease;
}

.skip-link:focus {
	top: 1rem;
}
</style>
